import Vue from "vue";
import Router from "vue-router";
import Home from "./../components/Home";
import PaginaNaoEncontrada from "./../components/utils/PaginaNaoEncontrada";
import Dashboard from "./../components/dashboard/Dashboard";
import DashboardGeral from "./../components/dashboard/DashboardGeral";
import AclUser from "./../components/acl/Acl";
import Cfg from "./../components/cfg/Cfg";
import CadUser from "./../components/Cadastros/Assesores.vue";
import CadCandidatos from "./../components/Cadastros/Candidatos.vue";
import CadMetas from "./../components/Cadastros/Metas.vue";
import CadPessoas from "./../components/Cadastros/Pessoas.vue";
import CadPessoasGeral from "./../components/Cadastros/PessoasGeral.vue";

Vue.use(Router);

const roteador = new Router({
  mode: "history",
  routes: [
    {
      path: "",
      name: "Home",
      component: Home
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/dashboard_geral",
      name: "dashboard_geral",
      component: DashboardGeral
    },
    {
      path: "/acl",
      name: "acl",
      component: AclUser
    },
    {
      path: "/configuracoes",
      name: "cfg",
      component: Cfg
    },
    {
      path: "/cadastros/assessores",
      name: "cadastro_assessores",
      component: CadUser
    },
    {
      path: "/cadastros/candidatos",
      name: "cadastro_candidatos",
      component: CadCandidatos
    },
    {
      path: "/cadastros/metas",
      name: "cadastro_metas",
      component: CadMetas
    },
    {
      path: "/cadastros/pessoas",
      name: "cadastro_pessoas",
      component: CadPessoas
    },
    {
      path: "/cadastros/pessoasGeral",
      name: "cadastro_pessoas_geral",
      component: CadPessoasGeral
    },
    {
      path: "*",
      name: "Not found",
      component: PaginaNaoEncontrada
    }
  ]
});

//Validador Guardião de Rotas

roteador.beforeEach((to, from, next) => {
  const url = to.path;
  let teste = 0;


  if (url != "/") {
    let rotas = localStorage.getItem("urls").split(",");
    rotas.push("/");
    rotas.push("/dashboard");
    rotas.push("/dashboard_geral");

    rotas.forEach(rota => {
      if (rota === url) {
        teste = 1;
        return;
      }
    });

    if (teste === 0) {
      const itens = [
        "token",
        "nome",
        "service",
        "setor",
        "hash_acesso",
        "urls",
        "empresa"
      ];

      if (localStorage.length > 1) {
        itens.forEach(item => {
          localStorage.removeItem(item);
        });
      }

      next(false);
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default roteador;
